/**
 * Default color definitions for each platform
 */
export const PLATFORM_COLOR_DEFAULTS: Record<string, Record<string, string>> = {
  SCRATCH: {
    motion: '#4C97FF',
    looks: '#9966FF',
    sound: '#CF63CF',
    events: '#FFD500',
    control: '#FFAB19',
    sensing: '#5CB1D6',
    operators: '#59C059',
    variables: '#FF8C1A',
    myblocks: '#FF6680',
  },
  MICROBIT: {
    basic: '#19B5E7',
    input: '#D400D4',
    music: '#e63022',
    led: '#5c2d91',
    radio: '#e3008c',
    loops: '#00aa00',
    logic: '#00a4a6',
    variables: '#dc143c',
    math: '#9400d3',
  },
  COSPACES: {
    scene: '#4A90E2',
    objects: '#7B68EE',
    animation: '#FF69B4',
    events: '#FFD700',
    control: '#FF8C00',
    logic: '#32CD32',
    math: '#9370DB',
    variables: '#FF6347',
  },
};

/**
 * Get default color definitions for a given platform
 */
export function getDefaultColorDefinitions(platform?: string): Map<string, string> {
  if (!platform || !(platform in PLATFORM_COLOR_DEFAULTS)) {
    return new Map();
  }

  const defaults = PLATFORM_COLOR_DEFAULTS[platform];
  return new Map(Object.entries(defaults));
}
